<template>
  <div ref="tags-container-outer" class="tag_container_outer">
    <el-tooltip
      effect="dark"
      content="点击查看左侧标签页"
      placement="top-start"
    >
      <span
        class="arrow-icon arrow-icon-left"
        @click="handleMove('right')"
        @mousedown="handleAutoRemove('leftOver')"
        @mouseup="handleAutoRemove('leftOut')"
      >
        <i class="el-icon-arrow-left"></i>
      </span>
    </el-tooltip>

    <div ref="tags-container-inner" class="tags_container_inner">
      <!-- :closable="!tag.active" -->
      <el-tag
        size="medium"
        v-for="(tag, index) in cacheRouteList"
        :key="tag.name"
        :closable="index !== 0 || (index === 0 && cacheRouteList.length > 1)"
        :class="{ active: tag.active }"
        @close="handleClose(tag)"
      >
        <router-link :to="getToLink(tag)" class="tags-li-title">
          <span
            :ref="`someOneTag_${tag.title}`"
            @click="handleLink($event, tag)"
            >{{ tag.title }}</span
          >
        </router-link>
      </el-tag>
    </div>

    <el-tooltip
      effect="dark"
      content="点击查看右侧标签页"
      placement="top-start"
    >
      <span class="arrow-icon arrow-icon-right" @click="handleMove('left')">
        <i class="el-icon-arrow-right"></i>
      </span>
    </el-tooltip>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Tabsview',
  computed: {
    ...mapGetters(['userInfo', 'cacheRouteList']),
  },
  methods: {
    /** 技改需求 20231031 https://bailongma.yuque.com/hhwu0d/nvrent/ivvalkzuuhe5yged */
    ...mapMutations({
      activeRoute(commit, r) {
        // 标记活跃
        commit('ACTIVE_CACHE_ROUTE', r)
      },
      handleClose(commit, currentRoute) {
        // 通知到 appmain做缓存删除操作 删除路由缓存
        this.$EventBus.$emit('autoRemoveCache', currentRoute)
        // 点击关闭跳转
        commit('DELETE_CACHE_ROUTE', {
          currentRoute,
          callback: (p) => {
            this.$router.push({
              path: this.getToLink(p),
            })
          },
        })
      },
    }),
    // 获取跳转链接
    getToLink(tag) {
      return tag.fullPath
    },
    handleAutoRemove(tags) {
      const outer = this.$refs['tags-container-outer']
      const inner = this.$refs['tags-container-inner']
      if (inner.scrollWidth > outer.scrollWidth) {
        // let overAll = 0
        const interval = setInterval(() => {
          // overAll += 1
          if (tags === 'leftOver') {
            // inner.scrollLeft = inner.scrollLeft + overAll 先不加长按效果
          } else if (tags === 'leftOut') {
            clearInterval(interval)
          }
        }, 20)
      }
    },
    handleLink(e, item) {
      const inner = this.$refs['tags-container-inner']
      const endMount = 10
      let overAll = 0
      const interval = setInterval(() => {
        overAll += 1
        if (e.clientX < 340) {
          inner.scrollLeft -= overAll
        } else if (e.clientX > 1356 && e.clientX < 1406) {
          inner.scrollLeft += overAll
        }
        if (overAll === endMount) {
          clearInterval(interval)
        }
      }, 16)
      /** 点击时 需要将其他的active换成false 当前这个 */
      setTimeout(() => {
        this.activeRoute(item)
      }, 10)
    },
    handleMove(tag) {
      const outer = this.$refs['tags-container-outer']
      const inner = this.$refs['tags-container-inner']
      const endMount = 20
      if (inner.scrollWidth > outer.scrollWidth) {
        let overAll = 0
        const interval = setInterval(() => {
          overAll += 1
          if (tag === 'left') {
            inner.scrollLeft += overAll
          } else if (tag === 'right') {
            inner.scrollLeft -= overAll
          }
          if (overAll === endMount) {
            clearInterval(interval)
          }
        }, 12)
      }
    },
    // 删除tab 通过store 变更 cacheRouteList
    autoClickTabRemove(index) {
      const spanDOM = this.$refs['tags-container-inner']?.children?.[index]
      const iDOM = spanDOM?.querySelector('i')
      if (iDOM) {
        iDOM.click()
      }
    },
    findCacheRouteIndex(route = this.$route) {
      const index = this.cacheRouteList.findIndex(
        (cacheRoute) =>
          cacheRoute.name === route.name && cacheRoute.path === route.path,
      )
      return [index, index !== -1 ? this.cacheRouteList[index] : null]
    },
    // 检索所有当前的缓存内容 找出需要刷新的内容
    autoRefreshCache(route = this.$route) {
      const { parent = null } = route.meta
      if (!parent) return
      const cacheRouteIndex = (value) => {
        if (!value) return
        const [index, cacheRoute] = this.findCacheRouteIndex(value)
        if (index === -1) return
        // 通知到 appmain做缓存删除操作 删除路由缓存
        this.$EventBus.$emit('autoRemoveCache', cacheRoute)
      }
      if (Array.isArray(parent)) {
        parent.forEach((element) => {
          cacheRouteIndex(element)
        })
        return
      }
      cacheRouteIndex(parent)
    },
    handleRemoveCurrent(componentInstance, dataKey, route, refreshStatus) {
      // 通过ref tags-container-inner 获取要删除的route 触发删除  :key="tag.name"
      // route === this.$route route 不传递也行
      const [index] = this.findCacheRouteIndex(route) // tab里没有就不需要刷新处理
      if (index === -1) return
      // 模拟点击 删除路由缓存
      this.autoClickTabRemove(index)
      // refreshStatus 代表关联刷新状态
      if (refreshStatus) {
        this.autoRefreshCache(route)
      }
    },
  },
  mounted() {
    this.$EventBus.$on('deleteCurrentRoute', this.handleRemoveCurrent)
    this.$EventBus.$on('refreshParent', this.autoRefreshCache) // 只是刷新父路由
  },
}
</script>
<style lang="less" scoped>
.tag_container_outer {
  background: rgb(255, 255, 255);
  position: relative;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.04);
}
.tags_container_inner {
  display: flex;
  // height: 45px;
  overflow-x: auto;
  padding: 6px 30px 6px 20px;
  flex-wrap: no-wrap;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  ::v-deep .el-tag--light {
    margin-left: 5px;
    a {
      color: rgba(0, 0, 0, 0.45);
    }
  }
  ::v-deep .el-tag {
    height: 26px;
    line-height: 26px;
    font-size: 13px;
    padding: 0 10px;
    border-radius: 5px;
    background-color: #fff;
    padding: 0, 20px;
  }
  ::v-deep .active {
    background: #f3f6ff;
    a {
      color: #276bec;
    }
  }
}
.bottom_liner {
  width: 100%;
  height: 7px;
  opacity: 1;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.05) 3%,
    rgba(0, 0, 0, 0) 99%
  );
}
::v-deep .el-icon-arrow-left {
  font-size: 15px;
  cursor: pointer;
  font-weight: bold;
  &:hover {
    color: #2e7eff;
  }
}
::v-deep .el-icon-arrow-right {
  font-size: 15px;
  cursor: pointer;
  font-weight: bold;
  &:hover {
    color: #2e7eff;
  }
}
.tags_container_inner::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
.arrow-icon {
  background: rgb(247, 248, 250);
  display: inline-block;
  z-index: 1500;
  height: 38px;
  line-height: 38px;
}
.arrow-icon-left {
  position: absolute;
  left: 0px;
  left: 0px;
  padding-left: 2px;
  padding-right: 2px;
  box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.1);
}
.arrow-icon-right {
  position: absolute;
  right: 0px;
  padding-right: 4px;
  padding-left: 2px;
  top: 0;
  box-shadow: -4px 0px 8px 0px rgba(0, 0, 0, 0.1);
}
</style>
